import './index.css';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import SnackbarProviderCDD from './components/SnackbarProviderCDD';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    //  <React.StrictMode>
    <Provider store={store}>
        <SnackbarProviderCDD>
            <App />
        </SnackbarProviderCDD>
    </Provider>
    //  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
